import store from '@/store'
export default {
    computed: {
       ratings() {return store.getters['app-ecommerce/getCurrentRatings']}
    }
}